export default __webpack_public_path__ + "static/7-0aec85421e4805542dccfdd2f9e3830f.webp";